"use strict";

var _classCallCheck = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _require = require("../helpers/node"),
    nodeRoot = _require.nodeRoot;

var _require2 = require("../../utils"),
    mixin = _require2.mixin;

var DocumentFragment = require("./DocumentFragment-impl").implementation;

var DocumentOrShadowRootImpl = require("./DocumentOrShadowRoot-impl").implementation;

var InnerHTMLImpl = require("../domparsing/InnerHTML-impl").implementation;

var ShadowRootImpl =
/*#__PURE__*/
function (_DocumentFragment) {
  _inherits(ShadowRootImpl, _DocumentFragment);

  function ShadowRootImpl(globalObject, args, privateData) {
    var _this;

    _classCallCheck(this, ShadowRootImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ShadowRootImpl).call(this, globalObject, args, privateData));
    var mode = privateData.mode;
    _this._mode = mode;
    return _this;
  }

  _createClass(ShadowRootImpl, [{
    key: "_getTheParent",
    value: function _getTheParent(event) {
      if (!event.composed && this === nodeRoot(event._path[0].item)) {
        return null;
      }

      return this._host;
    }
  }, {
    key: "mode",
    get: function get() {
      return this._mode;
    }
  }, {
    key: "host",
    get: function get() {
      return this._host;
    }
  }]);

  return ShadowRootImpl;
}(DocumentFragment);

mixin(ShadowRootImpl.prototype, DocumentOrShadowRootImpl.prototype);
mixin(ShadowRootImpl.prototype, InnerHTMLImpl.prototype);
module.exports = {
  implementation: ShadowRootImpl
};